import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b8108c4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-cross tag__close" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close", -1))
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["tag", [_ctx.color ? `tag--${_ctx.color}` : '', { 'tag--pill': _ctx.pill, 'tag--circle': _ctx.circle }]])
  }, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    (!_ctx.pill && !_ctx.circle)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "tag__close-button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.click && _ctx.click(...args))),
          title: "Close"
        }, _hoisted_3))
      : _createCommentVNode("", true)
  ], 2))
}